/* eslint-disable import/order */
import { calendarEntryPoint } from '@jira/spa-apps__business-calendar-new/src/calendarEntryPoint.entrypoint.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessCalendarCustomEmbedRoute } from '@jira/router-routes__business-calendar-routes/src/jiraBusinessCalendarCustomEmbedRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import type { Route } from '@atlassian/react-resource-router';

const calendarEmbedPageEntrypoint = createChromelessEntryPoint({
	main: calendarEntryPoint,
});

export const jiraBusinessCalendarCustomEmbedRouteEntry: Route = createEntry(
	jiraBusinessCalendarCustomEmbedRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.calendar-embed-view',

		entryPoint() {
			return calendarEmbedPageEntrypoint;
		},

		layout: chromelessLayout,
		skeleton: ThemedLazySkeleton,
		resources: [...jiraSpaResources()],
		supportsProjectTheme: 'full',
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
